import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { v4 } from 'uuid';
import { keys } from '../constants/keys.esm.js';
import { LayoutType } from '../types/layouts.esm.js';

function getNewLayoutId(layout) {
  switch (layout.type) {
    case LayoutType.Default:
      if (layout.id !== keys["default"]) {
        return _objectSpread2(_objectSpread2({}, layout), {}, {
          id: keys["default"]
        });
      }
      return layout;
    case LayoutType.Custom:
      if (layout.id !== keys.custom) {
        return _objectSpread2(_objectSpread2({}, layout), {}, {
          id: keys.custom
        });
      }
      return layout;
    default:
      if (!layout.id) {
        return _objectSpread2(_objectSpread2({}, layout), {}, {
          id: v4()
        });
      }
      return layout;
  }
}

export { getNewLayoutId };
//# sourceMappingURL=get-new-layout-id.esm.js.map
